export default __webpack_public_path__ + "static/media/GFBOT_stg_app_link.1f17b7b4.png";